import { keyBy } from 'lodash';
import { dateToFormat, getDurationInYearByDate } from '../../DateTime';
import { apiUrl } from '../../apiUrl';

export const convertItem = (
  {
    id,
    attributes,
    relationships: { role } = {},
  },
  included,
) => {
  const groupedIncluded = keyBy(included, (incl) => `${incl.type}:${incl.id}`);

  // `last_expirience` (Phase A3) and `external_applications`
  // (Phase D) are inline UserResource attributes now. Both used
  // to be JR relationships whose include-pipeline drove expensive
  // multi-table JOINs to pull data the FE consumer only formatted
  // into a label / attachment popover. The BE now returns
  // `attributes.last_expirience = { role, vessel, date_on,
  // date_off }` and `attributes.external_applications = { data:
  // [...full attachment objects...] }` - both flow straight
  // through without an `included` roundtrip.
  const lastExp = attributes.last_expirience || {};
  const { role: lastRoleExp, vessel, date_on, date_off } = lastExp;
  const roleItem = role && role.data ? groupedIncluded[`${role.data.type}:${role.data.id}`] : null;


  // CREW: no avatar means no <img src>, not a request to a host that cannot
  // answer. This used to fall back to `https://pms.staff-centre.com/${…}`,
  // and every seafarer without a photo fired it as
  // `https://pms.staff-centre.com/null`.
  //
  // The fallback was unreachable by design: all four backend avatar readers
  // (user, client, crewman, profile resources) return either nil or an
  // ActiveStorage path, so a legacy PMS filename never arrives — the branch
  // could only ever be taken when the value was null. The host does not even
  // serve a certificate for its own name (CN = gw6.scglobal.group), so it
  // would have failed for a real filename too.
  const avatarFullPath = (attr) => apiUrl(attr.avatar);


  return {
    ...attributes,
    id,
    crewing_applicant_id: attributes.crewing_applicant_id,
    name: attributes.name,
    surname: attributes.surname,
    middle: attributes.middle,
    status: attributes.status,
    email: attributes.email,
    birthday: attributes.birthday,
    address: attributes.address,
    mobile_phone: attributes.mobile_phone,
    phonehome: attributes.phonehome,
    readiness_date: dateToFormat(attributes.readiness_date),
    fullName: `${attributes.surname} ${attributes.name} ${attributes.middle ? attributes.middle : '' }`,
    avatar: avatarFullPath(attributes),
    age: getDurationInYearByDate(attributes.birthday),
    role: roleItem ? { id: roleItem.id, title: roleItem.attributes.title } : undefined,
    lastExperience: (
      lastRoleExp ? `${lastRoleExp}, ${vessel}
        (${dateToFormat(date_on)} - ${date_off ? dateToFormat(date_off) : 'now'})`
        : 'None'
    ),
    external_applications: attributes.external_applications || { data: [] },
    // Include duplicates data if present
    duplicates_data: attributes.duplicates_data || [],
  };
};

export const convertItems = ({ data, included, ...json }) => ({
  data: {
    ...json,
    data: data.map((item) => convertItem(item, included)),
  },
});

export default convertItems;
